module.exports = __webpack_public_path__ + "img/1.2ed34e7a.jpg";